import { render } from "./About.vue?vue&type=template&id=26710aa3&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-26710aa3"

export default script